// extracted by mini-css-extract-plugin
module.exports = {"markdown":"_2Q9A4t","title":"_2PTLbk"};